module.exports = __webpack_public_path__ + "img/shape_rectangle--yellow.755d349.webp";